module.exports = "a{font-size:.8em}:host{float:left;margin-left:5px}\n"